import { createContext, type ReactNode, useContext } from 'react';

interface IDocumentImageOwnerContext {
  idTipoDocumento?: string;
  idLayoutTipoDocumento?: string;
}

const DocumentImageOwnerContext = createContext<IDocumentImageOwnerContext>({});

export function DocumentImageOwnerProvider({
  value,
  children,
}: {
  value: IDocumentImageOwnerContext;
  children: ReactNode;
}) {
  return (
    <DocumentImageOwnerContext.Provider value={value}>
      {children}
    </DocumentImageOwnerContext.Provider>
  );
}

export function useDocumentImageOwner(): IDocumentImageOwnerContext {
  return useContext(DocumentImageOwnerContext);
}
